import { NgFor } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { RootState } from '@next/core-lib/app';
import {
  AbstractDialogResultData,
  AbstractFormDialog,
  AbstractFormDialogData,
  FormDialogComponent,
} from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { ColumnSettings } from '../../models/reference-value-sheet.model';
import { setColumnSettings } from '../../store/reference-value-sheet.actions';
import { getColumnSettings } from '../../store/reference-value-sheet.selectors';

export type ColumnSettingsDialogInputData = AbstractFormDialogData;

export interface ColumnSettingsDialogResultData {
  displayedColumns: Array<string>;
}

@Component({
  selector: 'app-column-settings',
  templateUrl: './column-settings.component.html',
  imports: [FormDialogComponent, ReactiveFormsModule, NgFor, MatSlideToggle, TranslatePipe],
})
export class ColumnSettingsComponent
  extends AbstractFormDialog<ColumnSettingsDialogResultData>
  implements OnInit
{
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ColumnSettingsDialogInputData,
    protected readonly mdDialogRef: MatDialogRef<
      ColumnSettingsComponent,
      AbstractDialogResultData<ColumnSettingsDialogResultData>
    >,
    private readonly store: Store<RootState>,
    private readonly locale: LocaleService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.data.title = this.locale.translate('column-setting.description');

    this.store.select(getColumnSettings).subscribe((setting) => {
      this.displayedColumns = JSON.parse(JSON.stringify(setting));
    });

    this.columnSettingsArray.forEach((column) => {
      if (column === ColumnSettings.DAY) {
        this.columnSettings().push(new FormControl({ value: true, disabled: true }));
      } else if (this.displayedColumns.includes(column)) {
        this.columnSettings().push(new FormControl(true));
      } else {
        this.columnSettings().push(new FormControl(false));
      }
    });
  }

  displayedColumns: Array<string> = [];

  columnSettingsArray: string[] = ColumnSettings.COLUMN_SETTINGS_ARRAY_DEFAULT;

  formGroup = new FormGroup({
    columnSettings: new FormArray([]),
  });

  switchColumnSetting(event: MatSlideToggleChange, column: string): void {
    if (event.checked) {
      this.displayedColumns.push(column);
    } else {
      this.displayedColumns = this.displayedColumns.filter((x) => x !== column);
    }
  }

  save() {
    this.confirm({ displayedColumns: this.displayedColumns });
    this.store.dispatch(setColumnSettings({ value: this.displayedColumns, save: true }));
  }

  columnSettings(): FormArray {
    return this.formGroup.get('columnSettings') as FormArray;
  }
}
